import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { AreaMap } from 'src/app/domain/GS/area-map';
import { EAreaMapType } from 'src/app/domain/enum/area-map-type';
import { AreaMapService } from 'src/app/services/GS/area-map.service';
import { DocumentService } from 'src/app/services/document.service';

@Component({
    selector: 'app-map-selection-box',
    templateUrl: './map-selection-box.html',
    styleUrls: ['./map-selection-box.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MapSelectionMeasurenBoxDialog implements OnInit {

    private strategyId: number;
    // ExoticMeasureList: string[] = Object.values(EExoticMeasure).filter(x => !isNaN(Number(x))).map(x => StringConverter.getExoticMeasure(x as EExoticMeasure));
    AreaMapList: AreaMap[] = [];
    AreaMap: AreaMap;
    MapFile: string;
    type?: EAreaMapType;
    private excludedAreaMap: AreaMap[];

    constructor(
        private areaMapService: AreaMapService,
        private documentService: DocumentService,
        public dialogRef: MatDialogRef<MapSelectionMeasurenBoxDialog>,
        @Inject(MAT_DIALOG_DATA) public data) {
        this.strategyId = data.strategyId;
        this.type = data.type;
        this.excludedAreaMap = data.excludedAreaMap ?? [];
    }

    ngOnInit() {
        this.getAreaMapList();
    }

    getAreaMapList() {
        this.areaMapService.getAreaMapFromStrategy(this.strategyId, this.type).subscribe(x => {
            this.AreaMapList = x.filter(areaMap => !this.excludedAreaMap.some(excluded => excluded.Legend === areaMap.Legend));
        })
    }

    onChange(event: MatSelectChange) {
        this.getAreaMapFile(event.value);
    }

    getAreaMapFile(areaMap: AreaMap) {
        this.documentService.getMapImage(areaMap.Legend, this.strategyId).subscribe(x => {
            console.log(x);
            this.MapFile = x;
        })
    }

    CanAdd() {
        return true;
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onConfirm() {

        if (!this.CanAdd())
            return;

        this.dialogRef.close(this.AreaMap);
    }

}
